module.exports = __webpack_public_path__ + "static/media/pencil.6ce13608.png";